<div
    class="async-loader-container"
    [ngClass]="{
        'spinner-container': throbberContainerStyle && isLoading,
        'd-block h-100': !isLoading,
    }"
>
    @if (!isForInfinityScroll) {
        <ng-container
            *ngTemplateOutlet="
                spinner;
                context: { overlay: true, infinity: false }
            "
        ></ng-container>
    }

    @if (isForInfinityScroll || (!isLoading && !hasError) || overlayContent) {
        @if (
            spinnerPosition === 'top' &&
            isForInfinityScroll &&
            (isLoading || hasError)
        ) {
            <div
                class="d-block position-relative"
                [class.h-100]="isInitialLoad"
            >
                <ng-container
                    *ngTemplateOutlet="
                        spinner;
                        context: { overlay: false, infinity: true }
                    "
                ></ng-container>
            </div>
        }
        <ng-content></ng-content>
        @if (
            spinnerPosition === 'bottom' &&
            isForInfinityScroll &&
            (isLoading || hasError)
        ) {
            <div
                class="d-block position-relative"
                [class.h-100]="isInitialLoad"
            >
                <ng-container
                    *ngTemplateOutlet="
                        spinner;
                        context: { overlay: false, infinity: true }
                    "
                ></ng-container>
            </div>
        }
    }
</div>

<ng-template #spinner let-overlay="overlay" let-infinity="infinity">
    @if (isLoading || hasError) {
        <div>
            @if (isLoading) {
                @if (overlay && overlayContent) {
                    <div class="spinner-overlay"></div>
                }
                <wdx-spinner
                    [class.absolute-center]="!infinity"
                    [class.infinity-spinner]="infinity"
                    [class.initial-load]="isInitialLoad"
                    [class.top-spinner]="spinnerPosition === 'top'"
                ></wdx-spinner>
            }
            @if (hasError) {
                <h6>{{ SOMETHING_WENT_WRONG | translateTokenisedString }}</h6>
            }
        </div>
    }
</ng-template>
